/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BankSchool } from "../models/BankSchool";
import type { BankViewerExamsDto } from "../models/BankViewerExamsDto";
import type { BankViewerIntentDto } from "../models/BankViewerIntentDto";
import type { BankViewerSearchResultDto } from "../models/BankViewerSearchResultDto";
import type { BankViewerStatusDto } from "../models/BankViewerStatusDto";
import type { BankViewerTemplateDto } from "../models/BankViewerTemplateDto";
import type { BankViewerUnitDto } from "../models/BankViewerUnitDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class BankService {
  /**
   * 이 환경에 문제은행이 있는지 — 없으면 어드민 메뉴를 숨긴다
   * @returns BankViewerStatusDto
   * @throws ApiError
   */
  public static bankStatus(): CancelablePromise<BankViewerStatusDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/status",
    });
  }
  /**
   * 과목별 단원 목록(문제틀·문항 수)
   * @returns BankViewerExamsDto
   * @throws ApiError
   */
  public static bankExams(): CancelablePromise<BankViewerExamsDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/exams",
    });
  }
  /**
   * 단원 하나 — 소단원(출제 의도) 목록과 문제틀·문항 수
   * @returns BankViewerUnitDto
   * @throws ApiError
   */
  public static bankUnit({
    key,
    school,
  }: {
    /**
     * 단원 key — 예: math/algebra
     */
    key: string;
    /**
     * 주면 그 학교급 소단원만
     */
    school?: BankSchool;
  }): CancelablePromise<BankViewerUnitDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/unit",
      query: {
        key: key,
        school: school,
      },
    });
  }
  /**
   * 중단원(출제 의도) 하나 — 단계별 문제틀과 문제틀마다 대표 문항 하나
   * @returns BankViewerIntentDto
   * @throws ApiError
   */
  public static bankIntent({
    key,
  }: {
    /**
     * 출제 의도 key — 예: algebra/E14
     */
    key: string;
  }): CancelablePromise<BankViewerIntentDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/intent",
      query: {
        key: key,
      },
    });
  }
  /**
   * 문제틀 하나 — 머리와 만들어 둔 문항(정답·풀이·선지별 오답 종류 포함)
   * @returns BankViewerTemplateDto
   * @throws ApiError
   */
  public static bankTemplate({
    key,
  }: {
    /**
     * 문제틀 key — 예: S-E14-E001a
     */
    key: string;
  }): CancelablePromise<BankViewerTemplateDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/template",
      query: {
        key: key,
      },
    });
  }
  /**
   * key 로 찾기 — 문제틀 key·문항 key·문항 id
   * @returns BankViewerSearchResultDto
   * @throws ApiError
   */
  public static bankSearch({
    q,
  }: {
    q: string;
  }): CancelablePromise<BankViewerSearchResultDto> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/bank/search",
      query: {
        q: q,
      },
    });
  }
}
